import React, { useContext, useState, useEffect } from 'react';
import classnames from 'classnames';
import { AnimatePresence } from 'framer-motion';
import { AppContext } from '../utils/reducers';
import Adiv from './AnimatedDiv';

import { ReactComponent as IconClose } from '../assets/images/icon-close.svg';

const HeadsUp = () => {
  const { state, dispatch } = useContext(AppContext);
  const [hudTimer, setHudTimer] = useState();
  
  useEffect(() => {
    clearTimeout(hudTimer);

    if (state.message) {
      const _timer = setTimeout(() => {
        closeAction();
      }, state.message ? state.message.type === 'error' ? 7000 : 4000: 4000);
      setHudTimer(_timer);

      return () => { clearTimeout(hudTimer); }
    }
  }, [state.message]);

  useEffect(() => {
    return () => {
      clearTimeout(hudTimer);
      dispatch({ type: 'SET_MESSAGE', message: null });
    }
  },[]);

  const closeAction = () => {
    clearTimeout(hudTimer);
    dispatch({ type: 'SET_MESSAGE', message: null });
  }

  return (
    <AnimatePresence exitBeforeEnter>
      {state.message &&
        <Adiv className={classnames('hud-message', `${state.message ? 'type-' + state.message.type : ''}`, { 'active': !!state.message })} animation="hud" onClick={state.message.click ? state.message.click : null}>
          {state.message ? state.message.content : ''}
          <div className="close-button" onClick={closeAction}>
            <IconClose />
          </div>
        </Adiv>
      }
    </AnimatePresence>
  )
}

export default HeadsUp;